/** Admin-console presentation helpers for an org's Wave-3 `kind`. */
import type { OrgKind } from "@talenthop/shared";

export const KIND_LABEL: Record<OrgKind, string> = {
  end_customer: "End customer",
  vendor: "Vendor",
  platform: "Platform",
};

/** Pill class per kind — reuses the existing app.css pill palette. */
export const KIND_PILL: Record<OrgKind, string> = {
  end_customer: "pill t",
  vendor: "pill pv",
  platform: "pill n",
};
